import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import { track } from "@/lib/track";

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function PathwayCard({ pathway, index }) {
  const Icon = pathway.icon;
  const { card } = pathway;
  return (
    <motion.div variants={cardVariants}>
      <Link
        to={pathway.route}
        onClick={() => track("pathway_selected", pathway.key)}
        data-testid={`pathway-card-${pathway.key}`}
        aria-label={`${card.title} — ${card.description}`}
        className={`pw-${pathway.key} pw-card pw-card-glow group relative block overflow-hidden rounded-[28px] border border-[#D6BB7C]/40 shadow-[0_24px_60px_-28px_rgba(0,0,0,0.85)] transition-all duration-300 hover:-translate-y-1 hover:border-[#D6BB7C]/80 hover:shadow-[0_30px_70px_-26px_rgba(214,187,124,0.45)] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#D6BB7C]/60`}
      >
        <picture className="absolute inset-x-0 top-0 h-[280px] sm:inset-y-0 sm:left-0 sm:h-full sm:w-[60%]">
          <source srcSet={`${pathway.image}.webp`} type="image/webp" />
          <img
            src={`${pathway.image}.jpg`}
            alt={pathway.imageAlt}
            width={720}
            height={720}
            style={pathway.imagePosition ? { objectPosition: pathway.imagePosition } : undefined}
            loading={index < 2 ? "eager" : "lazy"}
            fetchPriority={index === 0 ? "high" : "auto"}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
          />
        </picture>
        <div className="pw-card-overlay absolute inset-0" />
        <div className="relative flex flex-col pt-[200px] pb-6 px-6 sm:pt-8 sm:pb-8 sm:pl-[50%] sm:pr-8 sm:min-h-[320px] sm:justify-center">
          <span className="w-[52px] h-[52px] rounded-full border-2 border-[#D6BB7C] bg-black/25 backdrop-blur-sm flex items-center justify-center shadow-[0_0_0_6px_rgba(214,187,124,0.14)]">
            <Icon className="w-6 h-6 text-[#D6BB7C]" strokeWidth={2} />
          </span>
          <h2 className="mt-4 font-serif text-[30px] sm:text-[34px] font-semibold leading-[1.1] text-[#F6F1E7]">{card.title}</h2>
          <p className="mt-2.5 text-[15px] sm:text-base leading-relaxed text-[#F6F1E7]/85 max-w-[300px]">{card.description}</p>
          <div className="mt-5 flex items-center justify-between gap-4">
            <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.26em] text-[#D6BB7C]">{card.tagline}</span>
            <span className="w-12 h-12 shrink-0 rounded-full bg-[#D6BB7C] text-[#111E30] flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(214,187,124,0.7)] transition-transform duration-300 group-hover:translate-x-1">
              <ChevronRight className="w-6 h-6" strokeWidth={2.6} />
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
